import { PropsWithChildren, ReactNode } from 'react';
import { cn } from '@qodo/design-system';

export type StepProps = {
  title?: string;
  description?: ReactNode;
  className?: string;
};

const isValidDescription = (value: ReactNode) =>
  Array.isArray(value) ? value.length > 0 : Boolean(value);

export const Step = ({
  title,
  description,
  className: propsClassName,
  children,
}: PropsWithChildren<StepProps>) => {
  const className = cn('flex flex-col gap-6', propsClassName);
  const hasValidDescription = isValidDescription(description);

  const renderTitleIfNeeded = () => {
    if (!title) return <></>;

    return (
      <div role="heading" className="text-h5 text-text-general-neutral-strong">
        {title}
      </div>
    );
  };

  const renderDescriptionIfNeeded = () => {
    if (!hasValidDescription) return <></>;

    return (
      <div className="flex flex-col gap-1 text-text-general-neutral-mild">
        {description}
      </div>
    );
  };

  const renderHeaderIfNeeded = () => {
    if (!title && !hasValidDescription) return <></>;

    return (
      <div className="flex flex-col gap-2">
        {renderTitleIfNeeded()}
        {renderDescriptionIfNeeded()}
      </div>
    );
  };

  return (
    <div className={className}>
      {renderHeaderIfNeeded()}
      {children}
    </div>
  );
};
